import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { PieChart } from 'react-minimal-pie-chart'
import SummaryStatItem from './SummaryStatItem'
import { RISK_TYPE } from '../ultils/chart-d3-utils'

const useStyles = makeStyles(theme => {
  return {
    indexBoard: {
      padding: '10% 28%',
    },
    typeContainer: {
      padding: '23px 20px 28px 20px',
      width: 200,
    },
    pieChart: {
      position: 'relative',
      width: 200,
    },
    innerBox: {
      position: 'absolute',
      top: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '200px',
      width: '200px',
      pointerEvents: 'none',
    },
    titleText: {
      fontSize: '12px',
      fontWeight: 600,
      lineHeight: '18px',
      letterSpacing: '0em',
      position: 'relative',
      top: 6,
    },
    numberText: {
      fontSize: '28px',
      fontWeight: 600,
      lineHeight: '36px',
      letterSpacing: '0em',
    },
    companiesText: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '22px',
      position: 'relative',
      top: -6,
    },
  }
})

interface SummaryStatsBoxProps {
  total: number
  data: any
  riskType: any
  setMarblesData?: any
  segmentClicked: any
  setSegmentClicked: Function
}

const SummaryStatsBox = ({
  total,
  data,
  riskType,
  setMarblesData,
  segmentClicked,
  setSegmentClicked,
}: SummaryStatsBoxProps) => {
  const classes = useStyles()
  const [activeSegment, setActiveSegment]: any = useState(data[0])
  const getNumberOfRiskCount = () => {
    if (riskType === RISK_TYPE.CREDIT) {
      return segmentClicked?.creditRiskNumber || activeSegment.count
    }
    return segmentClicked?.equityRiskNumber || activeSegment.count
  }
  return (
    <div className={classes.indexBoard}>
      <div className={classes.pieChart}>
        <PieChart
          animate
          animationDuration={500}
          animationEasing="ease-out"
          lineWidth={35}
          radius={90}
          viewBoxSize={[200, 200]}
          center={[100, 100]}
          onMouseOver={(_, i) => setActiveSegment(data[i])}
          onMouseOut={() => setActiveSegment(data[0])}
          onClick={(_, i) => {
            if (segmentClicked?.index === i) {
              setMarblesData(null)
              setSegmentClicked(null)
            } else {
              setMarblesData(data[i])
              setSegmentClicked(data[i])
            }
          }}
          segmentsShift={i =>
            i === activeSegment.index || i === segmentClicked?.index ? 5 : 0
          }
          segmentsStyle={{ transition: 'all 0.2s', cursor: 'pointer' }}
          data={data}
        />
        <div className={classes.innerBox}>
          <div
            className={classes.titleText}
            style={{ color: segmentClicked?.color || activeSegment.color }}
          >
            {segmentClicked?.title || activeSegment.title}
          </div>
          <div className={classes.numberText}>{getNumberOfRiskCount()}</div>
          <div className={classes.companiesText}>Companies</div>
        </div>
      </div>
      <div className={classes.typeContainer}>
        {data
          .filter((d: any) => d.title !== 'Total')
          .map((d: any) => (
            <SummaryStatItem d={d} total={total} key={d.title} />
          ))}
      </div>
    </div>
  )
}

export default SummaryStatsBox
